import { Group, Text } from '@mantine/core'
import { WireInstructionParams } from 'app/models/wire-instruction-params'
import CustomHoverCard from './custom-hover-card'
import '../../../styles/components/hover-card-wire-instruction.css'
import IonIcon from '@reacticons/ionicons'

interface Props {
  wireInstruction: WireInstructionParams
  fromWireInstructions?: boolean
}

const WireInstructionHoverCard = ({ wireInstruction, fromWireInstructions }: Props) => {
  const cardTitle = 'Wire Instruction'
  const targetComponent = fromWireInstructions ? (
    <div
      className="sectionItemTitleClickable"
      style={{
        width: 30,
        height: 30,
        aspectRatio: '1 / 1',
        color: '#32439A',
      }}
    >
      <IonIcon name="information-circle" />
    </div>
  ) : (
    <Text className="sectionItemTitleClickable text-15">
      {wireInstruction.currency}
    </Text>
  );

  const wireInstructionData: Record<string, { label: string; value: string | undefined | null }[]> = {
    'Standard': [
      { label: 'Currency', value: wireInstruction.currency },
      { label: 'Bank ABA #', value: wireInstruction.accountWithInstitutionBankAba },
      { label: 'Account with Institution Name', value: wireInstruction.accountWithInstitutionName },
      { label: 'Beneficiary Customer Name', value: wireInstruction.beneficiaryCustomerName },
      { label: 'Beneficiary Account #', value: wireInstruction.beneficiaryAccountNumber },
      { label: 'Payment Reference', value: wireInstruction.paymentReference }
    ],
    'Intermediary': [
      { label: 'Currency', value: wireInstruction.currency },
      { label: 'Intermediary Bank name', value: wireInstruction.intermediaryBank?.bankName },
      { label: 'Intermediary Bank Swift/ABA', value: wireInstruction.intermediaryBank?.bankBic || wireInstruction.intermediaryBank?.bankAba },
      { label: 'Beneficiary Customer Name', value: wireInstruction.beneficiaryCustomerName },
      { label: 'Beneficiary Account #', value: wireInstruction.beneficiaryAccountNumber },
      { label: 'Payment Reference', value: wireInstruction.paymentReference }
    ],
    'ISO20022': [
      { label: 'Currency', value: wireInstruction.currency },
      { label: 'Receiver BIC', value: wireInstruction.receiverBic },
      { label: 'Creditor Agent', value: wireInstruction.creditorAgent },
      { label: 'Creditor Agent BIC', value: wireInstruction.creditorAgentBic },
      { label: 'Creditor', value: wireInstruction.creditor },
      { label: 'Creditor Account #', value: wireInstruction.creditorAccount },
      { label: 'Creditor IBAN', value: wireInstruction.iban },
      { label: 'Payment Reference', value: wireInstruction.paymentReference }
    ],
    'CorrespondentBank': [
      { label: 'Currency', value: wireInstruction.currency },
      { label: 'Correspondent Bank name', value: wireInstruction.correspondentBank?.bankName },
      { label: 'Correspondent Bank Swift/ABA', value: wireInstruction.correspondentBank?.bankAba || wireInstruction.correspondentBank?.bankBic },
      { label: 'Account with Institution Name', value: wireInstruction.accountWithInstitutionName },
      { label: 'Beneficiary Name', value: wireInstruction.beneficiaryCustomerName },
      { label: 'Beneficiary Account #', value: wireInstruction.beneficiaryAccountNumber },
      { label: 'Payment Reference', value: wireInstruction.paymentReference }
    ]
  }

  return (
    <CustomHoverCard cardTitle={cardTitle} targetComponent={targetComponent}>
      <div className='hover-card-wi-container'>
        <div className='hover-card-wi-content'>
          {wireInstructionData[wireInstruction.paymentInstructionType].map((data, index) => (
            <Group key={index} position='apart' className='hover-card-wi-group'>
              <Text className='hover-card-wi-text bold'>{data.label}</Text>
              <Text className='hover-card-wi-text'>{data.value}</Text>
            </Group>
          ))}
        </div>
      </div>
    </CustomHoverCard>
  )
}

export default WireInstructionHoverCard
